import React from 'react';
import Header7 from './components/Header7/Header7';
import Footer3 from './components/Footer3/Footer3';
import Form5 from './components/Form5/Form5';
import Gallery5 from './components/Gallery5/Gallery5';
import About3 from './components/About3/About3';

function App() {
  return (
    <>
      <Header7 />
      <About3 />
      <Gallery5 />
      <Form5 />
      <Footer3 />
    </>
  );
}

export default App;